import _toConsumableArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
function useAccordion(_ref) {
  var onlyOneItemOpen = _ref.onlyOneItemOpen;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    openedItems = _useState2[0],
    setOpenedItems = _useState2[1];
  function openItemHandler(itemIndex) {
    if (onlyOneItemOpen) {
      setOpenedItems([itemIndex]);
    } else {
      setOpenedItems([].concat(_toConsumableArray(openedItems), [itemIndex]));
    }
  }
  function closeItemHandler(itemIndex) {
    var newOpenedItems = openedItems.filter(function (item) {
      return item !== itemIndex;
    });
    setOpenedItems(newOpenedItems);
  }
  return {
    openedItems: openedItems,
    openItemHandler: openItemHandler,
    closeItemHandler: closeItemHandler
  };
}
export { useAccordion as default };